import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React, { useCallback, useState } from "react";

import { Checkbox, Flex, Text } from "~/components/blocks";
import { TermsModal } from "~/components/partials";

import { PrivacyPolicyModal } from "../PrivacyPolicyModal";

type Props = {
  disabled: boolean;
  agreement: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const Link = styled("a")(({ theme }) =>
  css({
    color: theme.colors.text.primary,
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  }),
);

export const Agreement = React.memo((props: Props) => {
  const theme = useTheme();

  const [isOpenPolicy, setIsOpenPolicy] = useState(false);
  const [isOpenTerms, setIsOpenTerms] = useState(false);

  const handleClickPolicy = useCallback(() => setIsOpenPolicy(true), []);
  const handleClickTerms = useCallback(() => setIsOpenTerms(true), []);
  const handleClosePolicy = useCallback(() => setIsOpenPolicy(false), []);
  const handleCloseTerms = useCallback(() => setIsOpenTerms(false), []);

  return (
    <>
      <Flex alignItems="center">
        <Checkbox
          name="isAgreed"
          disabled={props.disabled}
          checked={props.agreement}
          onChange={props.onChange}
        />
        <Text size="m" marginLeft={theme.space.s}>
          <Link onClick={handleClickTerms}>利用規約</Link>及び
          <Link onClick={handleClickPolicy}>プライバシーポリシー</Link>
          に同意する
        </Text>
      </Flex>
      <TermsModal open={isOpenTerms} onClose={handleCloseTerms} />
      <PrivacyPolicyModal open={isOpenPolicy} onClose={handleClosePolicy} />
    </>
  );
});

Agreement.displayName = "Agreement";
